import { useState } from 'react';
import type { OuNode } from './ouTree';

export interface UseOuCascadeNavigationResult {
  breadcrumbPath: OuNode[];
  currentNode: OuNode;
  visibleChildren: OuNode[];
  drillInto: (nodeId: string) => void;
  // salta a breadcrumbPath[index]; índices >= breadcrumbPath.length no producen crash
  // (se ignoran vía slice) — un índice negativo NO se ignora: usa la semántica de slice
  // desde el final, así que el llamador debe pasar siempre un índice >= 0
  goToLevel: (index: number) => void;
}

function resolveBreadcrumb(root: OuNode, path: readonly string[]): OuNode[] {
  const breadcrumb = [root];
  let current = root;
  for (const nodeId of path) {
    const next = current.children.find(child => child.ou.id === nodeId);
    if (!next) break;
    breadcrumb.push(next);
    current = next;
  }
  return breadcrumb;
}

/** Navegación en cascada (un nivel a la vez) sobre el árbol de una única raíz. */
export function useOuCascadeNavigation(root: OuNode): UseOuCascadeNavigationResult {
  const [path, setPath] = useState<string[]>([]);
  const breadcrumbPath = resolveBreadcrumb(root, path);
  const currentNode = breadcrumbPath[breadcrumbPath.length - 1]!;

  function drillInto(nodeId: string): void {
    setPath(previousPath => [...previousPath, nodeId]);
  }

  function goToLevel(index: number): void {
    setPath(previousPath => previousPath.slice(0, index));
  }

  return { breadcrumbPath, currentNode, visibleChildren: currentNode.children, drillInto, goToLevel };
}
